import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useUnits() {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadUnits = useCallback(async () => {
    let { data, error } = await supabase
      .from('units')
      .select('*')
      .order('sort_order', { ascending: true });

    if (error) {
      const res = await supabase.from('units').select('*');
      data = res.data;
      error = res.error;
    }

    if (!error && data) {
      setUnits(data);
    } else {
      console.warn('Failed to load units:', error?.message);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    loadUnits();
  }, [loadUnits]);

  const coreUnits = units.filter(u => u.type === 'core');
  const electiveUnits = units.filter(u => u.type === 'elective');
  const allUnits = units;

  function getUnit(code) {
    return units.find(u => u.code === code);
  }

  function getUnitName(code) {
    const u = getUnit(code);
    return u ? u.name : code;
  }

  function getEvidenceRequirements(code) {
    const u = getUnit(code);
    return u ? u.evidence_requirements : null;
  }

  return {
    units,
    coreUnits,
    electiveUnits,
    allUnits,
    loading,
    getUnit,
    getUnitName,
    getEvidenceRequirements,
    reload: loadUnits,
  };
}
